module.exports = "https://cdn-social.hiplatform.com/images/48385ae7e51d108475ffd1b91a98edfe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/emojis/drink.svg
// module id = n0D8
// module chunks = 0